import { useEffect } from "react";

export function usePressEsc({
  visible,
  onClose,
  captureEvent = true,
}: {
  visible: boolean;
  onClose: VoidFunction;
  captureEvent?: boolean;
}) {
  useEffect(() => {
    if (visible) {
      document.addEventListener(
        "keyup",
        (e) => {
          const key = e.key;

          if (key === "Escape") {
            onClose();
          }
        },
        {
          passive: true,
          capture: captureEvent,
        }
      );
    }
  }, [visible, captureEvent, onClose]);
}
